
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15a4 4 0 004-4V6a4 4 0 10-8 0v5a4 4 0 004 4zm-2-9a2 2 0 114 0v5a2 2 0 01-4 0V6z"}}),_c('path',{attrs:{"d":"M19 11a1 1 0 00-2 0 5 5 0 11-10 0 1 1 0 10-2 0 7 7 0 006 6.92V20H8.89a.89.89 0 00-.89.89v.22a.89.89 0 00.89.89h6.22a.89.89 0 00.89-.89v-.22a.89.89 0 00-.89-.89H13v-2.08A7 7 0 0019 11z"}})])
          )
        }
      }
    